import { initialState, State, Action } from '../store/store';

export const mirrorActive = (state: State = initialState, { data }: Action): State => {
  return {
    ...state,
    mirrorActive: data as any,
  };
};
